module.exports = __webpack_public_path__ + "static/img/baojingjiechu.50a3c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/baojingjiechu.png
// module id = MolK
// module chunks = 24